// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".my__table[data-v-39ed0770]{width:100%}.my__table[data-v-39ed0770] .el-button--text{text-align:left}.my__table[data-v-39ed0770] .el-button--text span{word-break:break-all;white-space:normal}.my__table[data-v-39ed0770] .el-table__body,.my__table[data-v-39ed0770] .el-table__header{min-width:100%!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
